import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

import { HintOptions } from '@geniuspos/ui-shared';
import { ICellRendererParams } from 'ag-grid-community';
import { get, merge, isFunction } from 'lodash';

/**
 * this renderer support to show hint in cell
 * hintOptions can get by cellRendererParams or through getHintOptions in cellRendererParams
 * getHintOptions will override hintOptions fields value
 */
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-hinted-text-renderer',
  templateUrl: './hinted-text-renderer.component.html',
  styleUrls: ['./hinted-text-renderer.component.scss'],
})
export class HintedTextRendererComponent implements AgRendererComponent {
  public params: ICellRendererParams;

  public hintOptions: HintOptions = {
    container: 'body',
    placement: 'auto',
  };

  public constructor() {}

  public agInit(params: ICellRendererParams): void {
    this.params = params;

    const cellRendererParams = get(params, 'colDef.cellRendererParams', {});

    let getHintOptions: (params: ICellRendererParams) => HintOptions = get(
      cellRendererParams,
      'getHintOptions',
    );

    if (!isFunction(getHintOptions)) {
      getHintOptions = (): HintOptions =>
        get(cellRendererParams, 'hintOptions', this.hintOptions);
    }

    this.hintOptions = merge({}, this.hintOptions, getHintOptions(params));
  }

  public refresh(): boolean {
    return true;
  }
}
